import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import {
  LayoutSingleColumn,
  Page,
  ExternalLink,
  NamedLink,
} from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import css from './InquiryPage.module.css';

const InquiryPage = () => {
  // prettier-ignore
  return (
    <Page
      title="Palvelupyyntö | Paikallispalvelut"
      scrollingDisabled={false}
    >
      <LayoutSingleColumn
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.staticPageWrapper}>
          <div className={css.contentWrapper}>
            <div className={css.contentMain}>
              <h1 className={css.pageTitle}>
                <FormattedMessage id="InquiryPage.title" />
              </h1>

              <div className={css.contentSection}>
                <h2>
                  <FormattedMessage id="InquiryPage.howItWorksTitle" />
                </h2>
                <p>
                  <FormattedMessage id="InquiryPage.howItWorksDescription" />
                </p>
              </div>

              <div className={css.contentSection}>
                <h2>
                  <FormattedMessage id="InquiryPage.stepsTitle" />
                </h2>
                <ol className={css.stepsList}>
                  <li>
                    <FormattedMessage id="InquiryPage.step1" />
                  </li>
                  <li>
                    <FormattedMessage id="InquiryPage.step2" />
                  </li>
                  <li>
                    <FormattedMessage id="InquiryPage.step3" />
                  </li>
                  <li>
                    <FormattedMessage id="InquiryPage.step4" />
                  </li>
                </ol>
              </div>

              <div className={css.contentSection}>
                <h2>
                  <FormattedMessage id="InquiryPage.benefitsTitle" />
                </h2>
                <ul className={css.benefitsList}>
                  <li>
                    <FormattedMessage id="InquiryPage.benefit1" />
                  </li>
                  <li>
                    <FormattedMessage id="InquiryPage.benefit2" />
                  </li>
                  <li>
                    <FormattedMessage id="InquiryPage.benefit3" />
                  </li>
                </ul>
              </div>

              <div className={css.ctaSection}>
                <p>
                  <FormattedMessage id="InquiryPage.ctaText" />
                </p>
                <div className={css.ctaButtons}>
                  <NamedLink name="SignupPage" className={css.ctaButton}>
                    <FormattedMessage id="InquiryPage.ctaSignup" />
                  </NamedLink>
                  <NamedLink name="SearchPage" className={css.ctaButtonSecondary}>
                    <FormattedMessage id="InquiryPage.ctaBrowse" />
                  </NamedLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default InquiryPage;
